import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { ShoppingBag } from "@faire/web/slate/icons/foundation/ShoppingBag";
import React from "react";
export var useHowFaireWorksRetailerNodes = function useHowFaireWorksRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    HowFaireWorks: {
      id: "HowFaireWorks",
      label: strictLocalize({
        id: "VX1YoC",
        defaultMessage: [{
          "type": 0,
          "value": "Hoe werkt Faire"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(ShoppingBag, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      articles: [articles.FAQ.RETAILER_WHAT_IS_FAIRE, articles.PaymentsAndInvoices.NET_60_TERMS, articles.MyOrders.FAIRE_PROTECTION, articles.GettingStarted.RESELLER_ID],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "oKX21f",
        defaultMessage: [{
          "type": 0,
          "value": "Hoe werkt Faire?"
        }]
      })
    }
  };
};